import tmhRequest from '@/config/tmhRequest'

export default {

    searchApplyAdjustMoneyMyCardCount: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applyadjustmoneymycard/searchapplyadjustmoneymycardcount',
            method: 'post',
            data: data,
        })
    },

    searchApplyAdjustMoneyMyCardByPage: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applyadjustmoneymycard/searchapplyadjustmoneymycardbypage',
            method: 'post',
            data: data,
        })
    },

    createApplyAdjustMoneyMyCard: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applyadjustmoneymycard/createapplyadjustmoneymycard',
            method: 'post',
            data: data,
        })
    },

    closeApplyAdjustMoneyMyCard: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applyadjustmoneymycard/closeapplyadjustmoneymycard',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/apply/applyadjustmoneymycard.js